// Changes that wait for a second platform administrator (ADR 0041): one
// admin asks, a different admin approves, each confirming with a code.
import { Anchor, Stack, Text } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import type { Schemas } from "../../api/client";
import { Notice } from "../../shared/ui/Page";

export type Approval = Schemas["AdminApproval"];

export const APPROVALS_KEY = ["admin", "approvals"] as const;
export const APPROVALS_PATH = "/admin/approvals";

/** useRequested refreshes the approvals list after a change was sent for approval. */
export function useRequested() {
  const queryClient = useQueryClient();
  return useCallback(() => void queryClient.invalidateQueries({ queryKey: APPROVALS_KEY }), [queryClient]);
}

/** Requested tells the admin their change waits for another administrator. */
export function Requested() {
  const { t } = useTranslation();
  return (
    <Notice>
      <Stack gap={4} data-testid="change-requested">
        <Text size="sm">{t("changes.requested")}</Text>
        <Anchor component={Link} to={APPROVALS_PATH} size="sm">
          {t("changes.open")}
        </Anchor>
      </Stack>
    </Notice>
  );
}
